import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const SafeBoxServer = {
    Transfer: {
        /**
         * 交易列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/safe/transaction-list`,
                { params }
            );
        },
    },
    Profit: {
        /**
       * 收益列表
       */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/safe/income-list`,
                { params }
            );
        },
    },
}